import {AbstractDTO} from '../abstract';
import {FormDTO} from './form';
import {RuleDTO} from './rule';
import {FccDTO} from "./fcc";

declare let _: any;

export class RuleFormDTO extends AbstractDTO {
	form: FormDTO;
	rules: RuleDTO[] = [];
	product: object;
	test: object | null;
	fcc: FccDTO[];
	cngProduct: object;
	template;

	constructor(attributes?: Object) {
		super(attributes);
		attributes = attributes ? attributes : {};

		this.form = FormDTO.create(attributes['form']);
		this.rules = RuleDTO.createFromArray(attributes['rules']);
		this.product = attributes['product'] || {};
		this.test = attributes['test'] || null;
		this.fcc = attributes['fcc'] ? FccDTO.createFromArray(attributes['fcc']) : null;
		if (this.fcc) {
			this.form.settings.hasFcc = true;
			// get compSolrQuery from the form field, and the field list to optimize FormService.getComponentsFromSolr request
			const self = this;
			this.fcc.forEach(fcc => {
				self.form.settings.fccFL = self.form.settings.fccFL ? _.concat(self.form.settings.fccFL, fcc.getFieldList()) : fcc.getFieldList();
				fcc.fccConfig.forEach(fccConf => {
					if (fccConf.formFieldName) {
						let field = self.form.getFields().filter(field => field.key == fccConf.formFieldName);
						fccConf.compSolrQuery = field[0] ? field[0].compSolrQuery : '';
					}
				});
			});
		} else if (['cngForm', 'customTemplate', 'cngScreen'].indexOf(this.product['product_template_s']) != -1) {
			this.form.settings.hasFcc = true;
			this.fcc = [];
		}
		this.cngProduct = attributes['cngProduct'] || null;
		this.template = attributes['template'] || null;
	}

}